export const VOICEBOX_AVATAR_SIZE = 24;

// https://github.com/stardog-union/cloud-login/blob/main/src/api/voicebox/schemas.py
export enum VoiceboxApp {
  API = 'api',
  CLOUD = 'cloud',
  DESIGNER = 'designer',
  EXPLORER = 'explorer',
  STUDIO = 'studio',
}

// https://github.com/stardog-union/cloud-login/blob/main/src/api/voicebox/schemas.py
export enum VoiceboxResponseActionType {
  CHART = 'chart',
  CSV = 'csv',
  EXTERNAL_LLM = 'external_llm',
  MODELING_AND_MAPPING = 'modeling_and_mapping',
  REWRITTEN_QUERY = 'rewritten_query',
  SPARQL = 'sparql',
  URL = 'url',
}

export interface BaseVoiceboxMessage {
  conversationId: string;
  messageId: string;
  isRequest?: boolean;
}

export interface VoiceboxRequestMessage extends BaseVoiceboxMessage {
  app: VoiceboxApp;
  connectionId: string;
  query: string;
  context: Record<string, any>;
  isRequest: true;
}

export interface VoiceboxResponseAction {
  label?: string;
  type: VoiceboxResponseActionType;
  value: string;
}

export interface VoiceboxResponseMessage extends BaseVoiceboxMessage {
  result: string;
  actions?: VoiceboxResponseAction[];
  feedbackScore?: number;
  success: boolean;
  examples?: string[];
  isRequest?: false;
}

export type VoiceboxMessage = VoiceboxRequestMessage | VoiceboxResponseMessage;

export interface VoiceboxResponse {
  /**
   * the unique key for managing multiple instances of voicebox,
   * i.e. Studio notebook tabs
   */
  id: string | null;
  newMessage?: VoiceboxResponseMessage;
  /**
   * whether the request was successful
   */
  succeeded: boolean;
}
